import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';
import { ResponseContentType } from '@angular/http';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TenantService extends BaseDataService {
    constructor(protected dataService: DataService, private httpClient: HttpClient) {
        super(dataService, API_URL);
    }

    public GetXls(accountId: number,
        siteId: number,
        userId: number,
        moduleId: number,
        searchValue: string,
        contactTypeData: number,
        CategoryData: number,
        SubCategoryData: number,
        filterActive: number) {
        let url = `Tenant/GetXls?accountId=${accountId}&siteId=${siteId}&userId=${userId}&moduleId=${moduleId}&searchValue=${searchValue}&contactTypeData=${contactTypeData}&CategoryData=${CategoryData}&SubCategoryData=${SubCategoryData}&filterActive=${filterActive}`;

        return super.savePDF<any>(url, 'application/pdf');
    }

    public getTenantList(page: number, pageSize: number = 10, filter: any): Observable<IPagedResults<any>> {
        let url = `Tenant/GetAll`;
        return super.getAll<any>(url);
    }

    public getTenantListByCSV(data: string): Observable<IPagedResults<any>> {
        let url = `Tenant/GetTenantListByCSV?csv=${data}`;
        return super.getAll<any>(url);
    }

    public getTenantByAccountId(accountId: number): Observable<any> {
        return super.getAll<any>(`Tenant/GetAllByAccountId?accountId=${accountId}`);
    }

    public getTenantByAccountIdAndTenantId(accountId: number, tenantId: number): Observable<any> {
        return super.getAll<any>(`Tenant/GetAllByAccountId?accountId=${accountId}&siteId=${tenantId}`);
    }

    public getTenants(accountId: number,
        siteId: number,
        userId: number,
        moduleId: number,
        searchValue: string,
        contactTypeData: number,
        categoryData: number,
        subCategoryData: number,
        filterActive: number): Observable<any> {
        return super.getAll<any>(`Tenant/GetAllByAccountId?accountId=${accountId}&siteId=${siteId}&userId=${userId}&moduleId=${moduleId}&searchValue=${searchValue}&contactTypeData=${contactTypeData}&categoryData=${categoryData}&subCategoryData=${subCategoryData}&filterActive=${filterActive}`);
    }

    public getTenantBySiteId(id?: number): Observable<any> {
        return super.getAll<any>(`Tenant/GetAllBySiteId?siteId=${id}`);
    }

    public getTenantByTenantTypeId(id?: number, tenantTypeId?: number): Observable<any> {
        let url = `Tenant/GetTenantByTenantTypeId?siteId=${id}&tenantTypeId=${tenantTypeId}`;
        return super.getAll<any>(url);
    }

    public getTenant(id?: number): Observable<any> {
        let url = `Tenant/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public getTenantTypeById(id?: number): Observable<any> {
        let url = `Tenant/GetTenantTypeById?id=${id}`;
        return super.getAll<any>(url);
    }

    public getPremiseTypeById(id?: number): Observable<any> {
        let url = `Tenant/GetPremiseTypeById?id=${id}`;
        return super.getAll<any>(url);
    }

    public getSubPremiseTypeById(id?: number): Observable<any> {
        let url = `Tenant/GetSubPremiseTypeById?id=${id}`;
        return super.getAll<any>(url);
    }

    public getAllTenantContacts(tenantId?: number): Observable<any> {
        let url = `Tenant/GetAllTenantContactsByTenantId?tenantId=${tenantId}`;
        return super.getAll<any>(url);
    }

    public sendUpdateEmail(data) {
        let url = `Tenant/SendUpdateEmail`;
        return super.save<any>(url, data);
    }

    public saveTenant(data) {
        let url = `Tenant/Save`;
        return super.save<any>(url, data);
    }

    public saveTenantPublic(data) {
        let url = `Tenant/saveTenantPublic`;
        return super.save<any>(url, data);
    }

    public deleteTenant(data) {
        let url = `Tenant/Delete`;
        return super.save<any>(url, data);
    }

    public saveTenantContact(data) {
        let url = `Tenant/SaveTenantContact`;
        return super.save<any>(url, data);
    }

    public saveTenantType(data) {
        let url = `Tenant/SaveTenantType`;
        return super.save<any>(url, data);
    }

    public savePremiseType(data) {
        let url = `Tenant/SavePremiseType`;
        return super.save<any>(url, data);
    }

    public saveSubPremiseType(data) {
        let url = `Tenant/SaveSubPremiseType`;
        return super.save<any>(url, data);
    }

    public saveJobTitleType(data) {
        let url = `Tenant/SaveJobTitle`;
        return super.save<any>(url, data);
    }

    public getAllTenantTypes(id?: number): any {
        let url = `Tenant/GetAllTenantTypes?accountId=${id}`;
        return super.getAll<any>(url);
    }

    public getAllPremiseTypes(id?: number): any {
        let url = `Tenant/GetAllPremiseTypes?accountId=${id}`;
        return super.getAll<any>(url);
    }

    public getAllSubPremiseTypes(id?: number): any {
        let url = `Tenant/GetAllSubPremiseTypes?accountId=${id}`;
        return super.getAll<any>(url);
    }

    public getAllJobTitles(id?: number): any {
        let url = `Tenant/GetAllGetJobTitles?accountId=${id}`;
        return super.getAll<any>(url);
    }

    public deleteTenantTypes(data) {
        let url = `Tenant/DeleteTenantType`;
        return super.save<any>(url, data);
    }

    public deletePremiseTypes(data) {
        let url = `Tenant/DeletePremiseType`;
        return super.save<any>(url, data);
    }

    public deleteSubPremiseTypes(data) {
        let url = `Tenant/DeleteSubPremiseType`;
        return super.save<any>(url, data);
    }

    public deleteJobTitle(data) {
        let url = `Tenant/DeleteJobTitle`;
        return super.save<any>(url, data);
    }

    public deleteTenantContact(data) {
        let url = `Tenant/DeleteTenantContact`;
        return super.save<any>(url, data);
    }

    public generateQr(contactId: number) {
        let url = `Tenant/Qr?contactId=${contactId}`;
        return super.savePDF<any>(url, 'application/pdf');
    }

    public generateQrs(data: any) {
        let url = `${API_URL}/Tenants/Qr`;
        return this.httpClient.post(url, data, { responseType: 'blob' })
    }

    public getContracts(id: number) {
        let url = `Tenant/GetContracts?tenantId=${id}`
        return super.getAll(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/tenant.service.ts